import isRRP from '@/helpers/isRRP';
import { IAccum, IEquipmentList } from './models/equipmentModel';
import { APP_CONFIG, CHANGE_PLAN, MOBILE_SHARE, NEWLINE, NUMBER_PORT, RECONTRACT, RRP_ACCESSORY, RRP_EQUIPMENT, SER_ROADSHOW } from '@/config/common';

export const generateEquipmentList = (catelogueData, defaultImg, equipmentList: IEquipmentList[] = []) => {
  return equipmentList.map((it) => {
    const equipObj = catelogueData.find((equip) => equip.modelCode === it.modelCode) || {
      heroImage: { childImageSharp: defaultImg }
    };
    return { ...equipObj, ...it };
  });
};

export const generateBrandList = (equipmentList = [] as IEquipmentList[]) => {
  return equipmentList.reduce((accum: IEquipmentList[] | IAccum[], it: IEquipmentList) => {
    const index = accum.findIndex((item: IEquipmentList | IAccum) => item.brandCode === it.brandCode);
    return index > -1 ? accum : [...accum, { brandCode: it.brandCode, brandDescription: it.brandDescription }];
  }, []);
};

export const getDefaultImg = (imageData, filename) => {
  return imageData.find((img) => {
    let imgName = img?.gatsbyImageData?.images?.fallback?.src.replace(/^.*[\\\/]/, '');
    if (imgName.includes(filename)) return true;
    return img.parent.name.includes(filename);
  });
};

export const getStepByShoppingCartType = (shoppingCartType, toNextPage) => {
  if (shoppingCartType === 'CHANGE_PLAN') {
    return {
      nextStep: 4,
      activeStep: 3,
      saveToCart: true,
      toOrderDetails: !!toNextPage
    }
  }
  return isRRP(shoppingCartType)
    ? {
      nextStep: 2,
      activeStep: 1,
      saveToCart: true,
      toOrderDetails: !!toNextPage
    }
    : {
      nextStep: 3,
      activeStep: 2,
      saveToCart: !toNextPage,
      toOrderDetails: false
    };
};

export const getEarlyReconPayload = (isEarlyRecon, serviceNumbers) => {
  if (!isEarlyRecon) return {};
  const list = serviceNumbers.map((item) => ({
    serviceNumber: item.serviceNumber,
    ciDate: item.ciDate
  }));
  return { earlyRecontractDetails: list };
};

export const getDefaultArray = (value) => { return value || [] }
export const getDepAddon = (watchDepAddons) => { return getDefaultArray(watchDepAddons).length > 0 ? true : false }

export const getNoDevice = (shoppingCartType, showButton, value) => {
  if (([NEWLINE, MOBILE_SHARE, CHANGE_PLAN, NUMBER_PORT, SER_ROADSHOW].includes(shoppingCartType) || (shoppingCartType === RECONTRACT && showButton)) && value?.length <= 0) return true;
  return false;
}

export const getValidCollapsible = (isCollapsible, value) => {
  if (isCollapsible || (!isCollapsible && value.length)) return true;
  return false;
}

export const getStockCount = (stockInfo) => {
  if (stockInfo.stockCount > 0) return stockInfo.stockCount;
  return 0;
}

export const getValidQuantity = (shoppingCartType, name) => {
  if (([NEWLINE, RECONTRACT, RRP_ACCESSORY, RRP_EQUIPMENT, CHANGE_PLAN, NUMBER_PORT].includes(shoppingCartType) && name === 'accessories') ||
    ([RRP_EQUIPMENT].includes(shoppingCartType) && name === 'equipments')) {
    return true;
  }
  return false;
}

export const getVariantMobileShare = (currentOrder) => {
  const { shoppingCartType = '', cartDetails = {} } = currentOrder
  const { planTypeCode = '', pricePlanGroupId = '' } = cartDetails?.pricePlan || {}
  return ([NEWLINE, MOBILE_SHARE].includes(shoppingCartType) && planTypeCode === APP_CONFIG.MOBILESHARE_PLAN_TYPE) ||
    pricePlanGroupId === APP_CONFIG.MOBILESHARE_PLAN ||
    pricePlanGroupId === 'Others'
};

export const isSerDevice = (cartDetails, serDeviceList) => {
  const equipmentList = [...cartDetails.equipments, ...cartDetails.accessories]
  const deviceList: any = []
  serDeviceList.forEach((device) => {
    equipmentList.forEach((equip) => {
      if (equip.deviceCode === device.equipmentCode && equip?.serDevice) {
        deviceList.push(device)
      }
    })
  })
  if (deviceList.length > 0) return true;
  return false;
};

export const isSerSim = (simCard, serviceNos, svcNoList) => {
  const deviceList: any = []
  svcNoList.forEach((svcNo) => {
    serviceNos.forEach((svc) => {
      if (svc.number === svcNo.serviceNumber && simCard.simCardType === svcNo.cardProfile) {
        deviceList.push(svcNo)
      }
    })
  })
  if (deviceList.length > 0) return true;
  return false;
};

export const getSerDeviceByModalCode = (modelCode, serDeviceList) => {
  return serDeviceList.some((device) => modelCode === device.modelCode)
};

export const getSerDeviceByDeviceCode = (deviceCode, serDeviceList) => {
  return serDeviceList.some((device) => deviceCode === device.equipmentCode)
};

export const findSerDevice = (deviceCode, serDeviceList) => {
  const equipmentList = serDeviceList.filter((device) => deviceCode === device.equipmentCode)
  if (equipmentList.length > 0) {
    const totalImei = equipmentList.reduce((acc, cur) => {
      const mappedImei = cur.imei.filter((ele) => ele.status !== 'R').map((ele) => ele.imei)
      return [...acc, ...mappedImei];
    }, [])
    const totalQuantity = equipmentList.reduce((acc, cur) => {
      return acc + cur.quantity;
    }, 0)
    return {
      equipment: equipmentList[0].equipment,
      equipmentCode: equipmentList[0].equipmentCode,
      imei: totalImei,
      modelCode: equipmentList[0].modelCode,
      quantity: totalQuantity
    }

  }
  return undefined;
};
